import {AbstractControl, ValidatorFn} from '@angular/forms';

export function zeroValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const forbidden = control.value <= 0 || /^0+$/.test(control.value);
    return forbidden ? {'zero': {value: control.value}} : null;
  };
}
